import { render, staticRenderFns } from "./WantToLeaveModal.vue?vue&type=template&id=f91f0e88&"
import script from "./WantToLeaveModal.vue?vue&type=script&lang=js&"
export * from "./WantToLeaveModal.vue?vue&type=script&lang=js&"
import style0 from "./WantToLeaveModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports